import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, withDefaults } from 'vue';
import { ITradingAccount } from '@/Interfaces';
import { Validations } from '@samc/centricity-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradingAccountFormModal',
  props: {
    tradingAccount: { type: null, required: true, default: () => null }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({ (event: 'close', value: ITradingAccount | null): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { tradingAccount: ITradingAccount | null };




const account = ref('');
const description = ref('');
const accountType = ref('');
const productType = ref('');
const bookId = ref('');
const referenceId = ref('');
const showValidations = ref(false);

const validations = computed((): Validations<ITradingAccount> => {
  let result: any = {}
  if (account.value.length == 0) {
    result.account = 'Account is required!';
  }
  return result;
});

const save = () => {
  showValidations.value = true;
  if (Object.keys(validations.value).length === 0) {
    const result = {
      account: account.value,
      ...props.tradingAccount,
      description: description.value,
      accountType: accountType.value,
      productType: productType.value,
      bookId: bookId.value,
      referenceId: referenceId.value
    } as ITradingAccount;

    emits('close', result);
  }
};

const cancel = () => {
  emits('close', null);
};

onMounted(() => {
  account.value = props.tradingAccount?.account ?? '';
  description.value = props.tradingAccount?.description ?? '';
  accountType.value = props.tradingAccount?.accountType ?? '';
  productType.value = props.tradingAccount?.productType ?? '';
  bookId.value = props.tradingAccount?.bookId ?? '';
  referenceId.value = props.tradingAccount?.referenceId ?? '';
});

return { __sfc: true,emits, props, account, description, accountType, productType, bookId, referenceId, showValidations, validations, save, cancel }
}

})